module.exports = __webpack_public_path__ + "img/128.9.a9b3468a.png";